<template>
    <div class="card">
        <div class="card-body">
            <h2 class="text-left"
                style="font-weight: 700 !important; font-size: 2.2em !important">Asset Activity - Last 6 months</h2>

            <h6 class="card-subtitle mt-1">This table shows the nr of tickets & inspections for each asset for the last 6 months</h6>
        </div>

        <div class="table-responsive">
            <table class="table table-hover no-wrap">
                <thead>
                <tr>
                    <th>ASSET</th>
                    <th class="text-center">NR OF TICKETS OPENED</th>
                    <th class="text-center">NR OF INSPECTIONS DONE</th>
                </tr>
                </thead>
                <tbody>

                <tr class="reporting-db-normalize-row" v-for="asset in assets">
                    <td><a :href="'/assets/' + asset.id" target="_blank">{{asset.name}}</a></td>
                    <td class="text-center pl-1 pr-1"> {{asset.ticket_count}}</td>
                    <td class="text-center pl-1 pr-1"> {{asset.inspection_count}}</td>
                </tr>

                </tbody>
            </table>
        </div>

        <el-pagination
            class="text-left mt-2"
            background
            small
            @current-change="fetchAssets"
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="total">
        </el-pagination>
    </div>

</template>

<script>
    export default {
        mixins: [require("../../mixins/vuetable-css-mixin")],

        name: "asset-stats",

        data () {
            return {
                searchParams: {},
                assets: [],
                total: 1,
                pageSize: 10
            };
        },

        created () {
            this.fetchAssets();
        },

        methods: {

            fetchAssets (page = 1) {
                axios.get("/reporting-dashboard/property-stats/all", {
                    params: {
                        current_page: page
                    }
                }).then(response => {
                    this.assets = response.data.data;
                    this.total = response.data.total_size;
                    this.pageSize = response.data.page_size;
                });
            }
        }
    };


</script>

<style scoped>

</style>
